import type { TFunction } from "i18next";
import type { EventListItemDto } from "../../autogen/bff-api";
import { osloDate, osloDateTime, type ExportCell } from "../../common/download/listExport";
import { displayPersonName } from "../../common/persons/displayPersonName";
import { publicStatusLabel } from "../../common/sourcing-events/EventStatusTag";
import { getContractNatureLabel } from "./portal/utils/displayFormatters";
import { procedureText, regulationText } from "./procurementClassificationText";

export interface ProcurementExportContext {
  t: TFunction;
  publishedLabel: string;
}

export const procurementListFileName = (now: Date): string => `Anskaffelser-${now.toLocaleDateString("sv-SE")}`;

export const procurementCell = (key: string, event: EventListItemDto, ctx: ProcurementExportContext): ExportCell => {
  const { t } = ctx;
  switch (key) {
    case "title":
      return { text: event.title || t("Untitled"), eventId: event.id };
    case "internalReference":
      return event.referenceId ? { text: event.referenceId } : null;
    case "status":
      return event.publicStatus ? { text: publicStatusLabel(event.publicStatus, t, ctx.publishedLabel) } : null;
    case "responsiblePersons":
      return { text: displayPersonName(event.responsible).trim() };
    case "contractType":
      return event.contractNature ? { text: getContractNatureLabel(event.contractNature, t) } : null;
    case "procedure":
      return textCell(procedureText(event, t));
    case "regulation":
      return textCell(regulationText(event, t));
    case "deadline":
      return event.deadline ? { dateTime: osloDateTime(event.deadline) } : null;
    case "modifiedAt":
      return { date: osloDate(event.modifiedAt) };
    default:
      return null;
  }
};

const textCell = (text: string | null): ExportCell => (text ? { text } : null);
